<template>
    <div>
        <!-- 根据参与人查询对应标的物小类 -->
        <Select :style="{width:width +'px'}" :placeholder="placeholder" :value="value" filterable clearable :disabled="disabled"  @on-change="onTargetList">
            <Option v-for="item in targetList" :value="item.code" :key="item.code">{{ item.text }}</Option>
        </Select>
    </div>
</template>

<script>
export default {
    model: {
        prop: 'value',
        event: 'on-change'
    },
    props: {
        width: {
            type: Number,
            default: 200
        },
        value: String,
        placeholder: {
            type: String,
            default: '请选择'
        },
        disabled:{
            type:Boolean,
            default:false
        }
    },
    data() {
        return {
            targetList: []
        }
    },
    mounted() {
        this.getTargetList()
    },
    methods: {
        // 标的物小类数据
        async getTargetList() {
            this.targetList = [];
            let data = {
                url: "CORE-CONTRACT/messageService/billingModelService/queryTargetTypesByLeaseeId",
                body: {
                    leaseeId: window.sessionStorage.getItem('memberId')
                }
            }
            this.targetList = await this.invoke(data)
        },
        onTargetList(val) {
            this.$emit('on-change', val)
        }
    }
}
</script>